import { BannerDTO } from '@/types/BannerDTO';
import { Button, ButtonProps, Grid, Typography, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import DefaultIcon from '@assets/icons/f-icon.svg';
import React, { FC, ReactElement } from 'react';

interface Props extends ButtonProps {
  banner: BannerDTO;
}

export const BannerItem: FC<Props> = (props: Props): ReactElement => {
  const { banner, ...other } = props;

  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  const handleNavigation = (): void => {
    if (banner?.redirectUrl) {
      window.open(banner?.redirectUrl, '_blank');
    }
  };

  return (
    <Button
      fullWidth={true}
      variant={'contained'}
      color={'secondary'}
      sx={(theme: Theme) => ({
        backgroundColor: '#f3f2f7',
        borderRadius: theme.spacing(0.75),
        padding: isMobile ? theme.spacing(1.5, 1.5) : theme.spacing(0.75, 1.5),
        '&:disabled': {
          color: 'inherit',
          backgroundColor: '#f3f2f7',
        },
      })}
      disabled={!banner?.redirectUrl}
      onClick={handleNavigation}
      {...other}>
      <Grid container={true} direction={'row'} alignItems={'center'} spacing={1.5} wrap={'nowrap'}>
        <Grid item={true} alignSelf={'start'}>
          <img
            src={banner?.icon ?? DefaultIcon}
            alt={'icon'}
            style={{
              display: 'block',
              width: '24px',
              height: '24px',
            }}
          />
        </Grid>
        <Grid item={true}>
          <Typography
            variant={'body1'}
            component={'div'}
            lineHeight={'20px'}
            textAlign={'left'}
            dangerouslySetInnerHTML={{ __html: banner?.content }}
          />
        </Grid>
      </Grid>
    </Button>
  );
};
